import axios from 'axios'

const CORE = axios.create({
    baseURL: process.env.VUE_APP_URL_CORE_SERVICE,
    headers: {
        Authorization: `Bearer ${localStorage.getItem(process.env.VUE_APP_TOKEN_ACCOUNT_KEY)}`
    }
});

export { CORE };